import { ChangeEvent, FormEvent, useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';

import Select from 'react-select'
import { useNavigate } from "react-router-dom";

export default function Form(props:any) {


//first thing done: update page title
useEffect(() => {
  document.title = 'Advanced Search - Vista Enhancer Browser'; 
}, []);

  let navigate = useNavigate();

  const [state, setState] = useState({
    vistaId: "",
    alleleId: 0,
    gene: "",
    genome: "hg38",
    stages: ['e8.5', 'e9.5', 'e10.5', 'e11.5', 'e12.5', 'e13.5', 'e14.5', 'e15.5', 'e16.5', 'e17.5'],
    expressions: ['positive', 'negative', 'allelic'],
    backbones: ['hZR', 'hZTR', 'gZH2', 'sZH', 'nZH'],
    tissues: [''],
    chr_num: "",
    chr_start: 0,
    chr_end: 0
  });
 

  const stageOptions = [
    { value: 'e8.5', label: 'e8.5' },
    { value: 'e9.5', label: 'e9.5' },
    { value: 'e10.5', label: 'e10.5' },
    { value: 'e11.5', label: 'e11.5' },
    { value: 'e12.5', label: 'e12.5' },
    { value: 'e13.5', label: 'e13.5' },
    { value: 'e14.5', label: 'e14.5' },
    { value: 'e15.5', label: 'e15.5' },
    { value: 'e16.5', label: 'e16.5' },
    { value: 'e17.5', label: 'e17.5' }
  ];

  const expressionOptions = [
    {value: "positive", label:"Positive"},
    {value: "negative", label:"Negative"},
    {value: "allelic", label:"Curated Allele"}
  ];



  const backboneOptions = [
    {value:'hZR', label:'Hsp68 (hZR)'},
    {value:'hZTR', label:'Hsp68 (hZTR)'},
    {value:'gZH2', label:'Betaglobin (gZH2)'},
    {value:'sZH', label:'Shh (sZH)'},
    {value:'nZH', label:'None (nZH)'}
  ];

  const tissueOptions = [
    {label: 'Blood vessels', value: 'bv' },
    { label: 'Branchial arch', value: 'ba' },
    { label: 'Cranial nerve', value: 'cn' },
    { label: 'Dorsal root ganglion', value: 'drg' },
    { label: 'Ear', value: 'ear' },
    { label: 'Eye', value: 'eye' },
    { label: 'Facial mesenchyme', value: 'fm' },
    { label: 'Forebrain', value: 'fb' },
    { label: 'Genital tubercle', value: 'gen' },
    { label: 'Heart', value: 'ht' },
    { label: 'Hindbrain', value: 'hb' },
    { label: 'Limb', value: 'lb' },
    { label: 'Liver', value: 'lv' },
    { label: 'Melanocytes', value: 'mel' },
    { label: 'Neural Crest Mesenchyme', value: 'mnc' },
    { label: 'Midbrain', value: 'mb' },
    { label: 'Neural tube', value: 'nt' },
    { label: 'Nose', value: 'nose' },
    { label: 'Other', value: 'other' },
    { label: 'Pancreas', value: 'pan' },
    { label: 'Somite', value: 'som' },
    { label: 'Tail', value: 'tail' },
    { label: 'Trigeminal V (ganglion, cranial)', value: 'tri' }
  ];

  const onFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    let value: (typeof state)[keyof typeof state] = event.target.value;
    console.log(value);
    if(event.target.name !== "stages" && event.target.name !== "expressions" && event.target.name !== "backbone") {
        setState({ ...state, [event.target.name]: value });
    }
    
  };


  const onStageChange = (event: any) => {
    var values: any[] = [];
    for(var i =0; i < event.length; i+=1) {
        values.push(event[i].value);
    }
    setState({ ...state, "stages": values });
  };

  const onExpressionChange = (event: any) => {
    var values: any[] = [];
    for(var i =0; i < event.length; i+=1) {
        values.push(event[i].value);
    }
    setState({ ...state, "expressions": values });
  };

  const onBackboneChange = (event: any) => {
    var values: any[] = [];
    for(var i =0; i < event.length; i+=1) {
        values.push(event[i].value);
    }
    setState({ ...state, "backbones": values });
  };


  const onTissueChange = (event: any) => {
    var values: any[] = [];
    for(var i =0; i < event.length; i+=1) {
        values.push(event[i].value);
    }
    setState({ ...state, "tissues": values });
  };



  const submitAdvancedSearch = async () => {
    var filters = [];
    if(state.vistaId) {
        var vistas=state.vistaId.split(" ").join(",").toLowerCase();
        filters.push("vistaId="+vistas);
    }
    if(state.alleleId > 0 && state.vistaId) {
        filters.push("alleleId="+state.alleleId);
    }
    if(state.stages.length > 0 && state.stages[0] !== '') {
        var stages = state.stages.join(',');
        filters.push("stage="+stages);
    }
    if(state.expressions.length > 0 && state.expressions[0] !== '') {
      var expressions = state.expressions.join(',');
      filters.push("expressions="+expressions);
    }
    if(state.tissues.length > 0 && state.tissues[0] !== '') {
      var tissues = state.tissues.join(',');
      filters.push("tissue="+tissues);
    }
    if(state.backbones.length > 0 && state.backbones[0] !== '') {
      var backbones = state.backbones.join(',');
      filters.push("backbone="+backbones);
    }
    if(state.gene) {
        var gn: string = "";
        if(state.gene) {
             gn = state.gene;
        }
        if(gn !== "")
            filters.push("bracket_"+state.genome+"="+gn);
    }
    if(state.chr_num && state.chr_num !== "") {
      var chr="chr"+state.chr_num;
      if(state.chr_start > 0 && state.chr_end > 0) {
        chr += ":"+state.chr_start+"-"+state.chr_end
        filters.push("coordinate_"+state.genome+"="+chr);
      }
    }
    if(filters.length >0) {
      var browseUrl = "/browse?advanced=true&" + filters.join("&");
      navigate(browseUrl);
    }
    else {
        window.alert("DO NOT PERFORM SEARCH")
    }
  };





  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    submitAdvancedSearch();
  };
 

  return (
    <Container style={{height:"88vh", width:"100vw"}}>
    <form className="form border px-2 py-2" onSubmit={onSubmit}>
                        <div className='row'>
                    <div className='col-md-3'>
                        <label><b>Vista ID:</b></label><br/>
                        <input type='text' className='form-control' name="vistaId" id="vistaId" placeholder='e.g. hs1 hs72 hs2766 hs218' onChange={onFieldChange}></input>
                        <span style={{fontSize:"12px"}}><i>Enter one or more Vista IDs, separated by spaces</i></span>
                    </div>
                    <div className='col-md-1'>
                        <label><b>Allele:</b></label>
                        <input type='number' className='form-control' name='alleleId' placeholder='0'  onChange={onFieldChange}></input>
                    </div>
                    <div className='col-md-4'>
                        <label><b>Stages:</b></label><br/>
                        <Select name='stages' options={stageOptions} isMulti={true} closeMenuOnSelect={false} defaultValue={stageOptions} onChange={onStageChange} />                   
                    </div>
                    <div className='col-md-4'>
                        <label><b>Expression:</b></label><br/>
                        <Select name='expressions' options={expressionOptions} isMulti={true} closeMenuOnSelect={false} defaultValue={expressionOptions} onChange={onExpressionChange} />

                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className='col-md-6'>
                            <label><b>Backbone:</b></label>
                            <Select name='backbones' options={backboneOptions} isMulti={true} closeMenuOnSelect={false} defaultValue={backboneOptions} onChange={onBackboneChange} /> 
                        </div>
                        <div className='col-md-6'>
                            <label><b>Tissue:</b></label>
                            <Select name='tissues' options={tissueOptions} isMulti={true} closeMenuOnSelect={false} defaultValue={tissueOptions} onChange={onTissueChange} /> 
                        </div>
                </div>
                <br/>
                <div className='row'>
                  <div className="col-md-2">
                    <label><b>Select Genome:</b></label><br/><br/>
                    <input type='radio' className='form-radio' name='genome' value='hg38' onChange={onFieldChange} defaultChecked/> <i>Homo sapiens</i> (hg38) &nbsp;<br/>
                    <input type='radio' className='form-radio' name='genome' value='mm10' onChange={onFieldChange} /> <i>Mus musculus</i> (mm10) &nbsp;
                  </div>
                   <div className='col-md-4'>
                   <label><b>Flanking gene(s):</b></label><br/>
                    <br/>
                                <input type='text' className='form-control' name='gene' placeholder='e.g. IRF8-FOXF1' onChange={onFieldChange} />
                </div>
                <div className="col-md-6">
                    <div className='row'>
                    <label><b>Chromosome position:</b></label><br/>
                    <div className="col-sm-2">
                      <label>Chromosome:</label>
                      <input type='text' className='form-control' name="chr_num" id="chr_num" placeholder='e.g. 1' onChange={onFieldChange} style={{"width":"100px"}}></input>
                      </div>
                      &nbsp;&nbsp;
                      <div className="col-sm-4">
                        <label>Start:</label>
                      <input type='number' className='form-control' name="chr_start" id="chr_start" placeholder='0' onChange={onFieldChange} ></input> &nbsp;
                      </div>
                      &nbsp;&nbsp;
                      <div className="col-sm-4">
                        <label>End:</label>
                      <input type='number' className='form-control' name="chr_end" id="chr_end" placeholder='0' onChange={onFieldChange}></input> &nbsp;
                      </div>
                </div>
                        </div>
                </div>
                <br/>
                <div className='text-center'>
                    <input className='btn btn-primary btn-lg rounded-0' type='submit' value='Perform Search'/> 
                </div>
                    <br/>
    </form>
    </Container>
  );
}